import React from 'react';
import styles from './StarRating.m.sass';

import cx from 'classnames';

export default class StarRating extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {displayedValue: props.value || 0};
  }

  render() {
    const {displayedValue} = this.state;

    return (
      <div className={styles.stars}>
        {[1, 2, 3, 4, 5].map(i => (
          <span
            key={i}
            className={cx(
              styles.star,
              {
                [styles.filled]: i <= displayedValue
              }
            )}
          />
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/starRating/StarRating.js